import { useCurrentPage } from '../pages';
import { useCarePortalPages } from './useCarePortalPages';
import { SideMenu, NavigationListItem } from '@act/storybook';
import CarePortalAvatarMenu from './CarePortalAvatarMenu';
import NotificationBellMenu from './NotificationBellMenu';
import { actingUserAppSelectors } from 'redux/slices/actingUserSlice';

const CarePortalSideMenu = () => {
  const page = useCurrentPage();
  const pages = useCarePortalPages();
  const actingUser = actingUserAppSelectors.useSelectActingUser();

  return (
    <SideMenu
      notificationMenu={<NotificationBellMenu />}
      subMenu={<CarePortalAvatarMenu />}
      showRecapButton={!!actingUser?.reecap}
    >
      {pages.map(pg => (
        <NavigationListItem
          key={pg.key}
          icon={pg.icon}
          postIcon={pg.postIcon}
          text={pg.label}
          isSelected={pg.key === page}
          onClick={pg.onClick}
        />
      ))}
    </SideMenu>
  );
};

export default CarePortalSideMenu;
